import { useContext, useEffect, useState } from "react";
import { UserContext } from "@modules/user/context";
import { PoliciesContext } from "@modules/cve/context";

export const useWritePolicyIds = () => {
	let [writePolicyIds, setWritePolicyIds] = useState([]);
	let { user, userStatus } = useContext(UserContext);
	let { policies, policiesStatus } = useContext(PoliciesContext);

	useEffect(() => {
		if (userStatus === "success" && policiesStatus === "success") {
			let { organizations, companies, groups, computers } = user.levels;

			let filteredPolicies = policies.filter(
				(policy) =>
					policy.levels.organizations.every(({ id }) => organizations.some((entity) => entity.id === id && !entity.readOnly)) &&
					policy.levels.companies.every(({ id }) => companies.some((entity) => entity.id === id && !entity.readOnly)) &&
					policy.levels.groups.every(({ id }) => groups.some((entity) => entity.id === id && !entity.readOnly)) &&
					policy.levels.computers.every(({ id }) => computers.some((entity) => entity.id === id && !entity.readOnly))
			);
			let policyIdsWithWriteAccess = filteredPolicies.map((policy) => policy.policyId);

			setWritePolicyIds(policyIdsWithWriteAccess);
		}
	}, [policies, policiesStatus, userStatus]);

	return { writePolicyIds };
};
